export { default } from './SimpleHeader';